import { normalizeText, formatDateShort } from '../../helpers'
import type { BillSummary, BillsIndex } from '../../models'
import type { Loadable } from '../../data'

// ExplorerIndexState mirrors the Rust enum of the same name.
export type ExplorerIndexState =
  | { kind: 'loading' }
  | { kind: 'error'; error: string }
  | { kind: 'ready' }

// explorerIndexState maps a Loadable<BillsIndex> to ExplorerIndexState.
//
// Mapping from Rust explorer_index_state(triggered: bool, resource: Option<Result<BillsIndex,String>>):
//   (false, _)          => Loading   — not yet triggered
//   (true, None)        => Loading   — triggered but still in-flight
//   (true, Some(Err))   => Error
//   (true, Some(Ok))    => Ready
//
// Our Loadable encodes the same states:
//   idle    → untriggered           → Loading
//   loading → triggered, in-flight  → Loading
//   error   → triggered, failed     → Error
//   ready   → triggered, succeeded  → Ready
export function explorerIndexState(loadable: Loadable<BillsIndex>): ExplorerIndexState {
  switch (loadable.status) {
    case 'idle':
    case 'loading':
      return { kind: 'loading' }
    case 'error':
      return { kind: 'error', error: loadable.error }
    case 'ready':
      return { kind: 'ready' }
  }
}

export function chamberDisplayLabel(chamber: string): string {
  const normalized = normalizeText(chamber)
  if (normalized.includes('senado')) return 'Senado'
  if (normalized.includes('diput')) return 'Cámara de Diputados'
  return chamber
}

export function subjectSummary(bill: BillSummary): string {
  if (bill.subjects.length === 0) return 'Sin tema'
  if (bill.subjects.length === 1) return bill.subjects[0]
  return `${bill.subjects[0]} +${bill.subjects.length - 1}`
}

export function recentActivityLabel(bill: BillSummary): string | null {
  if (bill.latest_vote_date == null) return null
  return `Última votación ${formatDateShort(bill.latest_vote_date)}`
}
